import * as React from "react";
import {Grid} from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import {UsuarioOperacionClienteForm}  from "../../Consola";

function UsuarioOperacionClientePage() {
  return (
    <SiteWrapper>
        <Grid.Col sm={12} lg={12}> 
        < UsuarioOperacionClienteForm  />
        </Grid.Col>
    </SiteWrapper>
  );
}
export default UsuarioOperacionClientePage;